var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentRouteComponent,{tag:"component",attrs:{"scene":_vm.scene,"router":this}})}
var staticRenderFns = []

export { render, staticRenderFns }